/*
 * @Author: your name
 * @Date: 2020-07-04 18:04:14
 * @LastEditTime: 2020-07-31 16:56:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /JiHE-university/src/store/modules/app.ts
 */

import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";

@Module({ dynamic: true, store: store, name: "app" })
export default class App extends VuexModule {
  landingPage = window.location.href;
  /** 登录相关流程，用户不能自主访问，不需要记录 */
  loginPathList = [
    "/login",
    "/login/wechat",
    "/bind-phone",
    "/module-of-interest",
    "/logout"
  ];
  /** 免登录路由 */
  whiteList = ([
    "/",
    "/login/no-code-reason",
    "/pay/flash-sale",
    "/flash-sale/buy-notice",
    "/pay/college",
    "/pay/course",
    "/protocol",
    "/privacy-policy",
    "/search",
    "/search/more-course",
    "/search/more-section",
    "/recommend-index",
    "/studies/experience-card",
    "/pay/valentine-day",
    "/day-sign",
    "/personal-center/studio-management/single-course/course-detail",
    "/study-circle/not-join-study",
    "/study-circle/join-circle/task-detail/checkin-detail",
    "/study-circle/join-circle/share/point-dtail",
    "/message/detail",
    "/lesson-session-detail",
    "/live-list",
    "/lesson-list",
    "/lesson-session-list",
    "/select-list",
    "/hot-list",
    "/course/throwing-screen",
    "/activity/douYin-advertising",
    "/activity/douYin-advertising-2",
    "/activity/douYin-success",
    "/activity/douyin/free-success",
    "/activity/douyin/1",
    "/activity/douyin/2",
    "/activity/douyin/3"
  ] as string[]).concat(this.loginPathList);
}

export const AppModule = getModule(App);
